<!-- GoodsSwipe.vue -->
<template>
	<div class="swipe-wrapper ui-common-swiper goodsbanner" v-if="detailInfo" :style="getBannerStyle">
		<div v-if="detailInfo.goodsvideo_url">
		<div class="m-btn show-btn" @click="$router.push({name:'HomeGoodsVideo'})"><span class="iconfont">&#xe6c5;</span>Video</div>
		</div>
    <!-- 轮播图 -->
		<mt-swipe
			:auto="0"
			class="ui-common-swiper goods-image"
			:prevent="false"
			:stop-propagation="true"
      :showIndicators="detailInfo.photos && detailInfo.photos.length>1"
			@change="handleChange"
		>
			<mt-swipe-item
				v-for="(item, index) in detailInfo.photos"
				v-bind:key="index"
				v-if="detailInfo.photos && detailInfo.photos.length > 0"
			>
				<img v-bind:src="item" v-on:click="setPopupVisible(index)" />
			</mt-swipe-item>
			<mt-swipe-item v-if="!detailInfo.photos || detailInfo.photos.length <= 0">
				<img
					src="../../../../assets/image/home/default_image_banner.png"
					class="product-img"
				/>
			</mt-swipe-item>
		</mt-swipe>

	</div>
</template>

<script>
import PreviewPicture from './PreviewPicture'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      popupVisible: false,
      index: 0
    }
  },

  components: {
    'v-picture': PreviewPicture
  },

  created () {
    this.$on('hide-priview-picture', value => {
      this.popupVisible = value
      this.setisPreviewPicture(value)
    })
  },

  computed: {
  	getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      
      return {
        height: itemWidth + 'px'
      }
    },
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo
    })
  },

  methods: {
    ...mapMutations({
      setisPreviewPicture: 'setisPreviewPicture',
      setSwiperId: 'setSwiperId'
    }),

    setPopupVisible () {
      this.popupVisible = true
      this.setisPreviewPicture(true)
    },

    handleChange (index) {
      this.index = index
      this.setSwiperId(index)
    }
  }
}
</script>

<style lang="scss">
	body .goodsbanner .mint-swipe-indicators{bottom: 10px;}
	.swipe-wrapper{position: relative}
	.goods-image{z-index: 10;top:0;left:0}
	.goods-video{position: absolute;z-index: 20;top:0;left:0;background: #000}
	.m-btn{position: absolute;font-size:1rem;}
	.close-btn{top:.5rem;right:.5rem;z-index: 30}
	.show-btn{bottom:.5rem;left:.5rem;z-index: 15;height: 1.5rem;line-height: 1.5rem;border-radius: 1.5rem;background: $primaryColor;color: #fff;font-size: .7rem;padding:0 .5rem;}
.ui-common-swiper {
	width: 100%;
	.mint-swipe-items-wrap {
		.mint-swipe-item {
			text-align: center;
			overflow: hidden;
			img {
				height: auto;
				width: 100%;
			}
		}
	}
	.mint-swipe-indicators {
		div.mint-swipe-indicator {
			background: #efeff4;
			opacity: 1;
			&.is-active {
				background: $primaryColor;
			}
		}
	}
}
</style>
